import { sendWebsocketMessage } from '../../../../../../App';

/**
 * If a tradeplan is deactivated, send this message to activate it.
 * This is related to if a trade plan is on repeating mode, if the user has the tradeplan
 * default to be reactivated each time around, and then he has to go and manually activate it
 */
export function activateTradePlan(tradePlanId, activate) {
  const message = {
    messageType: 'updateTradePlan',
    tradePlanId,
    value: activate,
    field: 'reactivateRestart',
  };
  sendWebsocketMessage(message);
}
